export const ENTER_KEY_PREVENTED = {
  bindings: {
    enter: {
      key: 13,
      handler: () => {
        console.warn('Enter key is prevented');
      },
    },
  },
};
